import createCustomContext from '../../../contexts/create-custom-context.js';

const [LegacyAutocompleteOptionsContextProvider, useLegacyAutocompleteOptionsContext] = createCustomContext('LegacyAutocompleteOptionsContext', {
  options: [],
  listBoxRef: {
    current: null
  }
});

export { LegacyAutocompleteOptionsContextProvider, useLegacyAutocompleteOptionsContext };
